import { AvailableSettings, StaticSettings } from '../definitions';

export const pyramidSettings: (AvailableSettings | StaticSettings)[] = [
    // Axis and Labels
    'axisLabelFontSize',
    'xAxis',
    'xAxisTitle',
    'areTicksRotated',
    'yAxis',
    'yAxisTitle',
    // Legend
    'showLegend',
    'showLegendOnRightSide',
    // Value Labels
    'areLabelsShown',
    'areLabelsVertical',
    // Colors
    'palette',
    'customPalette',
];
